import { isRequired } from '../../utils.js';

var universalMetadata = (_ref => {
  let {
    type = isRequired('type'),
    source = isRequired('source')
  } = _ref;
  return () => ({
    type,
    source
  });
});

export default universalMetadata;
